<template>
  <button class="uppercase border border-white rounded-full text-center flex items-center w-full px-3 gap-1">
    <span class="flex-grow"><slot /></span>
    <font-awesome-icon :icon="['fas', 'chevron-right']" />
  </button>
</template>
<script>
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';

import { library } from '@fortawesome/fontawesome-svg-core';

export default {
  name: 'BorderBtn',
  created() {
    library.add(faChevronRight);
  },
};
</script>
